import React from 'react';
import styled from 'styled-components';
import { SanityImage } from '@repo/ui-components/SanityImage';
import breakpoints from '@repo/ui-components/breakpoints';
import type { SanityFrontMatterImage } from '@repo/models/gatsby-graphql-types';

const SupportArticleImageWrapper = styled.div`
  img {
    display: block;
    margin: auto;
    max-width: 50%;
    max-height: 50%;
    width: auto;
    height: auto;
  }

  @media (max-width: ${breakpoints.md}) {
    img {
      height: 300px;
      margin-bottom: 0.25em;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }
`;

interface SupportArticleImageProps {
  image: SanityFrontMatterImage;
}

function SupportArticleImage({ image }: Readonly<SupportArticleImageProps>) {
  return (
    <SupportArticleImageWrapper>
      {image?.asset?._id && (
        <SanityImage
          id={image.asset._id}
          hotspot={image?.hotspot}
          crop={image?.crop}
          alt={image?.alt}
        />
      )}
    </SupportArticleImageWrapper>
  );
}

export default SupportArticleImage;
